import {useState,useEffect,useMemo} from 'react'
import {useDispatch} from 'react-redux'

import {
	useDeleteEvent,
	useSetEditor,
	useSetViewer,
	useEditor
} from './hooks'

import {
	makeGoogleCalendarUrl,
	makeOutlookCalendarUrl,
	makeICSCalendarUrl,
	makeTime,
	createLink,
	mapToDays
} from './util'

import {
	editCalendarEvent,
} from './slice'

import ReadableRepeat from './ReadableRepeat'

import Select from 'react-select'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'

import DatePicker from 'react-datepicker'
import TimePicker from '../TimePicker/TimePicker'

import {useGymTrainers,useClients} from '../users/hooks'
import useCurrentUser from '../../hooks/useCurrentUser'

import {
	dateToTimeObj,
	getTimeString,
	stringToTimeObject,
	dateToYMD
} from '../../util/datetime'
import {nMap,ellipsis} from '../../util/util'

export default function () {
	const dispatch = useDispatch()

	const {show,event,editSeries} = useEditor()

	const isRecurring = (
		event?.recurrence_type !== ''
		&& event?.recurrence_type !== 'none'
	)

	const isRequest = (
		parseInt(event?.status) === 0
	)

	const setEditor = useSetEditor()
	const setViewer = useSetViewer()

	const time = {start:{},end:{}}
	const date = event?.occurrence_date

	const onHide = ()=>{
		setEditor({
			show:false,
			id:null,
		})
	}

	const handleGoBack = ()=>{
		onHide()
		setViewer({
			show:true,
			id:event.id
		})
	}

	const {status:trainersStatus,trainers} = useGymTrainers()
	const {status:clientsStatus,clients} = useClients()

	const trainerOptions = useMemo(
		()=>trainers.map(t=>({
			label:t.user_name,
			value:t.user_id_number
		})),
		[trainers]
	)

	const clientOptions = useMemo(
		()=>clients.map(c=>({
			label:c.user_name,
			value:c.user_id_number
		})),
		[clients]
	)

	const user = useCurrentUser()

	const isTime24Hour = Number(user.is_24_hour_time) === 1

	const [title,setTitle] = useState(event?.title)
	const [description,setDescription] = useState(event?.body)
	const [trainingType,setTrainingType] = useState(event?.event_type)
	const [classSize,setClassSize] = useState('')
	const [link,setLink] = useState('')

	const [signupCancelBuffer,setSignupCancelBuffer] = useState(event?.signup_cancel_buffer)

	//repeat related state
	const [repeat,setRepeat] = useState('none')
	//daily
	const [dailyInterval,setDailyInterval] = useState(1)
	const [customDailyInterval,setCustomDailyInterval] = useState(1)
	//weekly
	const [weekDays,setWeekDays] = useState([])
	const [weeklyInterval,setWeeklyInterval] = useState()
	const daysOfTheWeek = ['sun','mon','tue','wed','thu','fri','sat']
	
	const weekDayDisplayNameMap = {
		sun:'Sunday',
		mon:'Monday',
		tue:'Tuesday',
		wed:'Wednesday',
		thu:'Thursday',
		fri:'Friday',
		sat:'Saturday'
	}

	const [startDate,setStartDate] = useState(new Date())
	const [endDate,setEndDate] = useState(new Date())
	const [noEndDate,setNoEndDate] = useState(false)

	const [createWorkouts,setCreateWorkouts] = useState(true)

	const [deductSession,setDeductSesion] = useState(true)
	const [deductSessions,setDeductSesions] = useState(true)

	const [selectedTrainers,setSelectedTrainers] = useState([])
	const [selectedClients,setSelectedClients] = useState([])

	const [startTime,setStartTime] = useState(time.start)
	const [endTime,setEndTime] = useState(time.end)


	const reminderOptions = [48,24,12,6,1]
	const [reminderTime,setReminderTime] = useState('none')
	const [emailReminders,setEmailReminders] = useState(false)
	const [pushReminders,setPushReminders] = useState(false)

	const [isSaving,setIsSaving] = useState(false)


	useEffect(()=>{
		if (!event) return 
		setTitle(event?.title)
		setDescription(event?.body)
		setTrainingType(event?.event_type)
		setSignupCancelBuffer(event?.signup_cancel_buffer)
		setClassSize(event?.group_session_size)
		setRepeat(
			Boolean(event?.recurrence_type) && editSeries
			? event?.recurrence_type
			: 'none'
		)

		setLink(event?.link)

		if (event.recurrence_type==='day') {
			if(event.interval>10){
				setDailyInterval('custom')
				setCustomDailyInterval(event.interval)
			}else{
				setDailyInterval(event.interval)
			}
		}

		if (event.recurrence_type==='week') {
			setWeeklyInterval(event.interval)
			setWeekDays(
				event.week_days.split(',').map(d=>daysOfTheWeek[parseInt(d)])
			)
		}

		setStartDate(
			(isRecurring && !editSeries)
			? new Date(`${event.occurrence_date}T${event.start_time}`)
			: new Date(event?.start_date?.split(' ').join('T'))
		)

		setEndDate(
			(isRecurring && !editSeries)
			? new Date(`${event.occurrence_date}T${event.end_time}`)
			: new Date(event?.end_date?.split(' ').join('T'))
		)

		setNoEndDate(Boolean(Number(event?.no_end_date)))

		setCreateWorkouts(Boolean(event?.create_workouts))

		setDeductSesion(Boolean(event?.deduct_session))
		setDeductSesions(Boolean(event?.deduct_sessions))

		console.log(event)

		setSelectedTrainers(
			event?.trainers.map(({user_id_number,user_name})=>(
				{label:user_name,value:user_id_number}
			))
		)

		setSelectedClients(
			clientOptions.filter(
				({value}) => event.client_id_arr.includes(parseInt(value))
			)
		)

		setStartTime(
			stringToTimeObject(
				event
				? event.start_time
				: '00:00:00',
				1
			)
		)

		setEndTime(
			stringToTimeObject(
				event
				? event.end_time
				: '00:00:00',
				1
			)
		)

		setReminderTime(
			(event&&event.reminder_time)
			? event.reminder_time
			: 'none'
		)

		setEmailReminders(
			event && event.send_email
		)

		setPushReminders(
			event && event.send_pushnote
		)

	},[event,clientOptions,trainerOptions])


	const handleUpdate = ()=>{
		setIsSaving(true)
		const payload = {
			action:'editCalendarEvent',
			start_date:`${dateToYMD(startDate)} ${getTimeString(startTime,1)}`,
			end_date:`${dateToYMD(endDate)} ${getTimeString(endTime,1)}`,
			recurrence_type:repeat,
			no_end_date:Number(noEndDate),
			signup_cancel_buffer:signupCancelBuffer,
			body:description,
			title,
			link,
			event_id:event?.calendar_id,
			event_type:trainingType,
			trainer_id:user.user_id_number,
			trainer_ids:selectedTrainers.map(({value})=>value),
			client_ids:selectedClients.map(({value})=>value).join(','),
			reminder_time:reminderTime,
			push_notifications:Number(pushReminders),
			email_notifications:Number(emailReminders),
			deduct_session:Number(deductSession),
			group_session_size:classSize,
			consume_session_credit:Number(deductSession),
			create_workouts:Number(createWorkouts),
			deduct_sessions:Number(deductSessions),
			event_status:'',
			edit_series:Number(editSeries)
		}
		//handle converting repeat related state into the 
		//day_string parameter expected by the API
		//day - an integer value coresponding to the interval
		//week - comma seperated list like mon,tue,wed
		if ( repeat==='day' ) {
			payload.day_string = (
				dailyInterval==='custom'
				? customDailyInterval
				: dailyInterval
			)
		} else if (repeat === 'week') {
			payload.day_string = weekDays
				.map(d=>daysOfTheWeek.indexOf(d))
				.sort((a,b)=>a-b)
				.join(',')
			payload.week_repeat_freq = weeklyInterval
		}

		if(isRecurring&&!editSeries){
			payload.old_start_date = `${event.occurrence_date} ${event.start_time}`
		}

		dispatch(editCalendarEvent(payload)).then(res=>{
			setIsSaving(false)
			if(res.payload.success==='1'){
				onHide()
			} else {
				window.alert(ellipsis(res.payload.message,80))
			}
		})
	}

	const handleAccept = ()=>{
		setIsSaving(true)
		//remove params that will cause API issues
		//because legacy... 
		const {trainer,...noConflict} = event
		const payload = {
			action:'editCalendarEvent',
			...noConflict,
			//so much legacy...
			event_id:event.calendar_id,
			edit_series:Number(editSeries),
			status:'',
		}

		if(Number(editSeries)===0){
			payload.start_date = `${event.occurrence_date} ${event.start_time}`
			payload.end_date = `${event.occurrence_date} ${event.end_time}`
			payload.old_start_date = `${event.occurrence_date} ${event.start_time}`
		}

		console.log(payload)

		dispatch(editCalendarEvent(payload)).then(res=>{
			setIsSaving(false)
			onHide()
		})
	}

	const handleDecline = ()=>{
		setIsSaving(true)
		//remove params that will cause API issues
		//because legacy... 
		const {trainer,...noConflict} = event
		const payload = {
			action:'editCalendarEvent',
			...noConflict,
			//so much legacy...
			event_id:event.calendar_id,
			edit_series:Number(editSeries),
			status:2,
		}

		if(Number(editSeries)===0){
			payload.start_date = `${event.occurrence_date} ${event.start_time}`
			payload.end_date = `${event.occurrence_date} ${event.end_time}`
			payload.old_start_date = `${event.occurrence_date} ${event.start_time}`
		}
		
		console.log(payload)

		dispatch(editCalendarEvent(payload)).then(res=>{
			setIsSaving(false)
			onHide()
		})
	}

	const headerText = (
		editSeries
		? 'Recurring Event'
		: 'Event'
	)

	const deleteEvent = useDeleteEvent()
	
	const handleDeleteSeries = ()=>{
		onHide()
		const payload = {
			edit_series: 1,
			event_type: event.event_type,
			event_id: event.calendar_id,
		}
		deleteEvent(payload)
	}

	const handleDeleteSingle = ()=>{
		onHide()
		const payload = {
			edit_series: 0,
			occurrence_id:event.id,
			event_type: event.event_type,
			event_id: event.calendar_id,
			old_start_date: `${event.occurrence_date} ${event.start_time}`
		}
		deleteEvent(payload)
	}

	console.log(selectedTrainers)

	function handleCreateLink(type) {
		if (!event) return ''
        const calendarEvent = {
            name: event.text,
            location: '',
            details: event.body,
            startsAt: event.start_date,
            endsAt: `${event.start_date.split(' ')[0]} ${event.end_time}`,
        }

        const repeatType = event.recurrence_type
        if(Boolean(repeatType)){
            const interval = event?.repeat_frequency
            const repeatWeekDays = mapToDays(event.week_days)

        

            if (repeatType === 'day') {
                calendarEvent.rrule = `RRULE:FREQ=DAILY;INTERVAL=${interval};UNTIL=${makeTime(event.end_date)}`
            } else if (repeatType == "week") {
                const standardizedWeekDay = repeatWeekDays.map(item => (item.slice(0, 2)))
                const byDay = standardizedWeekDay.join(",").toUpperCase();
                calendarEvent.rrule = `RRULE:FREQ=WEEKLY;INTERVAL=${interval};WKST=MO;BYDAY=${byDay};UNTIL=${makeTime(event.end_date)}`
            }
        }

        if(type==='google'){
            return makeGoogleCalendarUrl(calendarEvent)
        }
        if(type==='ics'){
            return makeICSCalendarUrl(calendarEvent)
        }
        if(type==='outlook'){
            return makeOutlookCalendarUrl(calendarEvent)
        }
    }
	


	if (!Boolean(event)) return null

	return (
		<Modal show={show} size="lg" onHide={onHide}>
			<Modal.Header>
				Edit {headerText}
			</Modal.Header>
			<Modal.Body>
				<div>
					<div>
						<small>Title</small>
						<Form.Control
							value={title}
							onChange={e=>{
								setTitle(e.target.value)
							}}
						/>
					</div>
					<div>
						<small>Description</small>
						<Form.Control 
							onChange={e=>{
								setDescription(e.target.value)
							}}
							value={description}
							as="textarea"
						/>
					</div>
					<div>
						<small>Link</small>
						<Form.Control
							value={link}
							onChange={e=>{
								setLink(e.target.value)
							}}
						/>
					</div>
				</div>
				<small>Type</small>
				<Form.Control 
					onChange={e=>{
						setTrainingType(e.target.value)
					}}
					value={trainingType}
					as="select" 
					className="mt-2"
				>
					<option value="training">
						Training Session
					</option>
					<option value="semi_private">
						Semi-private training session
					</option>
					<option value="personal">
						Personal/Unavailable
					</option>
					<option value="group_session">
						Class/Group Session
					</option>
					<option value="meeting">
						Meeting
					</option>
					<option value="notes">
						Notes
					</option>
					<option value="closed">
						Closed
					</option>
				</Form.Control>
				{trainingType==='training'&&
					<>
						<Form.Check
							onChange={e=>{
								setCreateWorkouts(e.target.checked)
							}}
							checked={createWorkouts}
							id="create-session-workouts-check"
							label="Add training session as a workout to client calendars."
						/>
						<Form.Check
							onChange={e=>{
								setDeductSesions(e.target.checked)
							}}
							checked={deductSessions}
							id="deduct-session-credit-check"
							label={`Deduct session credits`}
						/>
					</>
				}
				{trainingType==='semi_private'&&
					<div>
						<small>Training Session Size</small>
						<Form.Control 
							value={classSize}
							onChange={e=>{
								setClassSize(e.target.value)
							}}
						/>
						<Form.Check
							onChange={e=>{
								setCreateWorkouts(e.target.checked)
							}}
							checked={createWorkouts}
							id="create-semi-private-workouts-check"
							label="Add sessions as a workout to client calendars."
						/>
						<small>
							<OverlayTrigger overlay={
								<Tooltip>
									For example, setting this to 5 will prevent a client from being able to cancel or sign up 5 hours before the session
								</Tooltip>
							}>
								<i className="fa fa-info-circle mr-1"/>
							</OverlayTrigger>
							Signup/Cancel Limit
						</small>
						<Form.Control 
							type="number"
							onChange={e=>{
								setSignupCancelBuffer(e.target.value)
							}}
							value={signupCancelBuffer}
							placeholder="number of hours before"
						/>
					</div>
				}
				{trainingType==='group_session'&&
					<div>
						<small>Class Size</small>
						<Form.Control 
							value={classSize}
							onChange={e=>{
								setClassSize(e.target.value)
							}}
						/>
						<Form.Check
							onChange={e=>{
								setCreateWorkouts(e.target.checked)
							}}
							checked={createWorkouts}
							id="create-class-workouts-check"
							label="Add class as a workout to client calendars."
						/>
						<Form.Check
							onChange={e=>{
								setDeductSesion(e.target.checked)
							}}
							checked={deductSession}
							id="deduct-session-credit-check"
							label="Deduct session credit when client registers"
						/>
					</div>
				}
				{Boolean(editSeries)&&
					<div className="d-flex">
						<div className={repeat==='none'?'w-100':'w-50'}>
							<small>Recurring</small>
							<Form.Control 
								onChange={e=>{
									setRepeat(e.target.value)
								}}
								value={repeat}
								as="select" 
							>
								<option value="none">
									No Repeat
								</option>
								<option value="day">
									Daily
								</option>
								<option value="week">
									Weekly
								</option>
							</Form.Control>
						</div>
						{(repeat==='day')&&
							<div className="w-50 ml-1">
								<small>Repeat Frequency</small>
								<Form.Control 
									onChange={e=>{
										setDailyInterval(e.target.value)
									}} 
									value={dailyInterval} 
									as="select"
								>
									{nMap(10,(i)=>(
										<option value={i+1}>
											{
												i===0
												? 'Every day'
												: `Every ${i+1} days`
											}
										</option>
									))}
									<option value="custom">
										Custom
									</option>
								</Form.Control>
							</div>
						}
						{(repeat==='week'&&editSeries)&&
							<div className="w-50 ml-1">
								<small>Repeat Frequency</small>
								<Form.Control 
									placeholder="weeks"
									onChange={e=>{
										setWeeklyInterval(e.target.value)
									}} 
									value={weeklyInterval} 
								/>
							</div>
						}
					</div>
				}
				{!editSeries&&
					<div>
						<small>
							You are editing a single event that is part of a recurring series
						 </small>
					</div>
				}
				{(repeat==='week'&&editSeries)&&
					<div>
						<small>Days of the week</small>
						<div className="d-flex flex-wrap">
							{daysOfTheWeek.map(
								weekDay => (
									<Form.Check 
										size="sm"
										onChange={e=>{
											setWeekDays(
												p => (
													e.target.checked
													? [...p,weekDay]
													: p.filter(d=>d!==weekDay)
												)
											)
										}}
										checked={weekDays.includes(weekDay)}
										className="mr-2 mb-2"
										id={`create-weekday-check-${weekDay}`}
										label={weekDayDisplayNameMap[weekDay]}
									/>
								)
							)}
						</div>
					</div>
				}
				{(repeat==='day'&&dailyInterval==='custom'&&editSeries)&&
					<div>
						<small>Custom Repeat Frequency</small>
						<Form.Control
							onChange={e=>{
								setCustomDailyInterval(e.target.value)
							}}
							value={customDailyInterval}
						/>
					</div>
				}
				<div className="d-flex my-1 justify-content-between flex-wrap">
					<div>
						<small>{repeat==='none'||!editSeries?'Date':'Start Date'}</small>
						<InputGroup>
							<InputGroup.Prepend>
								<InputGroup.Text>
									<i className="fa fa-calendar"/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<DatePicker 
								onChange={date=>{
									setStartDate(date)
								}}
								selected={startDate}
								customInput={<Form.Control style={{borderRadius:'0 5px 5px 0'}}/>}
							/>
						</InputGroup>
						{repeat!=='none'&&
							<Form.Check
								className="mt-1"
								onChange={e=>{
									setNoEndDate(e.target.checked)
								}}
								checked={noEndDate}
								id="create-no-end-date-check"
								label="No end date"
							/>
						}
					</div>
					{(repeat!=='none'&&!noEndDate&&editSeries)&&
						<div>
							<small>End Date</small>
							<InputGroup>
								<InputGroup.Prepend>
									<InputGroup.Text>
										<i className="fa fa-calendar"/>
									</InputGroup.Text>
								</InputGroup.Prepend>
								<DatePicker 
									onChange={date=>{
										setEndDate(date)
									}}
									selected={endDate}
									customInput={<Form.Control style={{borderRadius:'0 5px 5px 0'}}/>}
								/>
							</InputGroup>
						</div>
					}
					<div className="text-center w-100">
						<ReadableRepeat 
							repeatType={repeat}
							eventType={trainingType} 
							startDate={startDate}
							endDate={endDate} 
							interval={
								repeat === 'week'
								? weeklyInterval
								: (
									dailyInterval === 'custom'
									? customDailyInterval
									: dailyInterval
								)
							} 
							weekDays={weekDays}
							weekRepeatFreq={
								weeklyInterval
							}
							noEndDate={noEndDate}
						/>
					</div>
					<div>
						<small>Time</small>
						<div className="d-flex align-items-center">
							<TimePicker
								onChange={newTimeObj=>{
									setStartTime(newTimeObj)
								}}
								minuteInterval={15}
								hour={startTime.hour}
								minute={startTime.min}
								period={startTime.p}
								isTime24Hour={isTime24Hour}
							/>
							<span>-</span>
							<TimePicker
								onChange={newTimeObj=>{
									setEndTime(newTimeObj)
								}}
								minuteInterval={15}
								hour={endTime.hour}
								minute={endTime.min}
								period={endTime.p}
								isTime24Hour={isTime24Hour}
							/>
						</div>
					</div>
				</div>
				{!['closed','notes','semi_private'].includes(trainingType)&&
					<div>
						<small>Trainers</small>
						<Select
							value={selectedTrainers}
							onChange={setSelectedTrainers}
							options={trainerOptions}
							isMulti
						/>
					</div>
				}
				{!['personal','meeting','notes'].includes(trainingType)&&
					<div>
						<small>Clients</small>
						<Select
							onChange={setSelectedClients}
							value={selectedClients}
							options={clientOptions}
							isMulti
						/>
					</div>
				}
				{trainingType!=='personal'&&
					<div>
						<small>Reminders</small>
						<Form.Control 
							onChange={e=>{
								setReminderTime(e.target.value)
							}}
							value={reminderTime} 
							as="select"
						>
							<option value="none">None</option>
							{reminderOptions.map(h=>(
								<option value={h}>
									{h} hours before event
								</option>
							))}
						</Form.Control>
						{reminderTime!=='none'&&
							<div>
								<Form.Check
									onChange={e=>{
										setPushReminders(e.target.checked)
									}}
									checked={pushReminders}
									id="create-push-note-check"
									label="Push Notifications"
								/>
								<Form.Check
									onChange={e=>{
										setEmailReminders(e.target.checked)
									}}
									checked={emailReminders}
									id="create-email-check"
									label="Email Notifications"
								/>
							</div>
						}
					</div>
				}
				<div className="mt-3 d-flex align-items-center">
					<i className="fas fa-inbox mr-2 "></i>
					<OverlayTrigger overlay={
						<Tooltip>Add to google calendar</Tooltip>
					}>
						<a className="btn btn-sm mr-2 btn-outline-primary" href={handleCreateLink('google')} target="_blank">
							<i className="fab fa-google"> </i>
						</a>
					</OverlayTrigger>
					<OverlayTrigger overlay={
						<Tooltip>Download to calendar app</Tooltip>
					}>
						<a className="btn btn-sm mr-2 btn-outline-primary" href={handleCreateLink('ics')} target="_blank">
							<i className="fab fa-apple"></i>
								<span className="mx-2">/</span>
							<i className="fab fa-microsoft"></i>
						</a>
					</OverlayTrigger>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button disabled={isSaving} onClick={handleGoBack} variant="outline-dark" className="mr-auto">
					Go Back
				</Button>
				{isRequest&&
					<>
						<Button onClick={handleDecline} disabled={isSaving} variant="outline-danger">
							Decline
						</Button>
						<Button disabled={isSaving} onClick={handleAccept} variant="outline-success">
							Accept
							{isSaving&&<Spinner animation="border" size="sm" className="ml-1"/>}
						</Button>
					</>
				}
				{!isRequest&&
					<div>
						<Button 
							disabled={isSaving} 
							onClick={
								editSeries
								? handleDeleteSeries
								: handleDeleteSingle

							} 
							variant="outline-danger" 
							className="mr-1"
						>
							Delete
						</Button>
						<Button disabled={isSaving||(!Boolean(selectedTrainers.length)&&!['meeting','closed','notes','semi_private'].includes(trainingType))} onClick={handleUpdate} variant="outline-success">
							Update {isSaving&&<Spinner animation="border" size="sm"/>}
						</Button>
						{(!Boolean(selectedTrainers.length)&&!['meeting','closed','notes','semi_private'].includes(trainingType))&&
							<small className="d-block">Please select a trainer</small>
						}
					</div>
				}
			</Modal.Footer>
		</Modal>
	)
}